<template>
  <div>
    <div class="row">
      <div class="col-lg-4">
        <ScheduleBuilder />
      </div>
      <div class="col-lg-8">
        <div class="row" v-if="!scheduleCards.length">
          <div class="col-md-4">
            <b-button class="bg-light card-body text-muted" @click="handleAddCards">
              <b-icon icon="plus-lg" style="width: 120px; height: 120px"></b-icon>
              <h3 class="my-0 text-muted">Add cards</h3>
            </b-button>
          </div>
        </div>
        <div v-else>
          <div class="mb-3">
            <div class="p-1">
              <div class="row align-items-center">
                <div class="col">
                  <b-button variant="primary" size="sm" @click="handleAddCards">
                    <b-icon icon="plus-lg"></b-icon> Add cards
                  </b-button>
                </div>
                <div class="col text-right">
                  <b-button variant="secondary" size="sm" @click="handleResetForm">Restore defaults</b-button>
                  <b-button variant="success" size="sm" @click="handleSaveSchedule" :disabled="!can.create">
                    Save schedule
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <VisualScheduleViewer :previewMode="true" />
        </div>
        <b-modal
          v-model="addCardModal"
          title="Add cards to the schedule"
          hide-footer
          modal-tall
          size="lg"
          data-test-id="add-card-modal"
        >
          <CardAdder @close-modal="addCardModal = false" />
        </b-modal>
      </div>
    </div>

    <DeviseAuth v-if="!userId" size="lg" :show="authModal" @close-modal="authModal = false">
      <template v-slot:mobile-image>
        <b-img :src="imageMobile" fluid class="d-lg-none w-100"></b-img>
      </template>
      <template v-slot:image>
        <b-img :src="image" fluid class="d-lg-block h-100"></b-img>
      </template>
    </DeviseAuth>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { EventBus } from './event-bus';
import ScheduleBuilder from './components/ScheduleBuilder.vue';
import CardAdder from './components/CardAdder.vue';
import VisualScheduleViewer from './components/VisualScheduleViewer.vue';
import DeviseAuth from '../components/DeviseAuth.vue';
import image from '../images/visual-schedule-login.jpg';
import imageMobile from '../images/visual-schedule-login-mobile.jpg';

export default {
  props: {
    newVisualSchedule: {
      type: Object,
      required: true,
    },
    abilities: {
      type: Object,
      required: true,
    },
    cards: {
      type: Array,
    },
    directUploadUrl: {
      type: String,
    },
    userId: {
      type: String,
    },
    cardTypes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      addCardModal: false,
      authModal: false,
      image,
      imageMobile,
    };
  },

  components: {
    DeviseAuth,
    ScheduleBuilder,
    CardAdder,
    VisualScheduleViewer,
  },

  created() {
    this.setNewVisualSchedule({
      ...this.newVisualSchedule,
      ...{
        visual_schedule_cards_attributes: [],
        visual_schedule_reveal_images_attributes: [],
      },
    });
  },

  mounted() {
    EventBus.$on('show-cta', this.showAuthModal);

    this.fetchVisualScheduleOptions();
    this.fetchImages();
    this.setAbilities(this.abilities);
    this.setDefaultCards(this.cards);
    this.setCardTypes(this.cardTypes);
    this.setUserId(this.userId);
    this.setDirectUploadUrl(this.directUploadUrl);
  },

  destroyed() {
    EventBus.$off('show-cta', this.showAuthModal);
  },

  computed: {
    ...mapState(['can']),
    ...mapGetters(['scheduleCards']),
  },

  methods: {
    ...mapActions(['setNewVisualSchedule', 'fetchVisualScheduleOptions']),
    ...mapMutations([
      'setAbilities',
      'setDefaultCards',
      'setDefaultImages',
      'setUserId',
      'setCardTypes',
      'setDirectUploadUrl',
    ]),

    fetchImages() {
      axios.get('/api/v2/reveal-images').then((response) => {
        this.setDefaultImages(response.data);
      });
    },

    handleAddCards() {
      this.addCardModal = true;
    },

    handleSaveSchedule() {
      if (this.can.create) EventBus.$emit('save-schedule');
    },

    handleResetForm() {
      EventBus.$emit('reset-form');
    },

    showAuthModal() {
      this.authModal = true;
    },
  },
};
</script>
